import Controller from '@ember/controller'
import { task } from 'ember-concurrency'
import type { BufferedChangeset } from 'ember-changeset/types'

export default class ManageTeachersTeacherController extends Controller {
  /* Located here, so that the task is not destroyed mid-save when the teacher values are updated for saving. Updating
   * teacher values causes the teacher table to re-render, since it tracks teacher values for the teacher view
   */
  saveTeacherTask = task({ drop: true }, async (teacherChangeset: BufferedChangeset, saveOptions?: object) => {
    await teacherChangeset.save(saveOptions)
  })
}
